import { fetchConversationMessages } from '@/api/queries/omnichannel/request';
import type { ChannelType, PaginatedMessagesResponse } from '@/types';

/** Fetches the newest messages page (resolves lastPage via a page-1 meta call). */
export const fetchLatestConversationMessagesPage = async (
  conversationId: string,
  params: { channel: ChannelType; pageId?: string }
): Promise<PaginatedMessagesResponse> => {
  const meta = await fetchConversationMessages(conversationId, {
    channel: params.channel,
    pageId: params.pageId,
    page: 1,
  });
  const lastPage = meta.lastPage || 1;
  if (lastPage <= 1) return meta;
  return fetchConversationMessages(conversationId, {
    channel: params.channel,
    pageId: params.pageId,
    page: lastPage,
  });
};
